module.exports = __webpack_public_path__ + "static/media/cap-china.9086f0df.png";